module.exports = __webpack_public_path__ + "img/deuterium.7008adbd.png";